<script setup>
// @desislavsd/vue-teleport 这个插件会影响组件层级关系，所以不要使用

const props = defineProps({
  to: {
    type: String,
    default: 'body'
  },
  // disable: [Boolean, Number] // 暂时不需要实现
})

const teleport = ref()

onMounted(() => {
  const target = document.querySelector(props.to) || document.body

  target.appendChild(teleport.value)
})

// onUnmounted(() => {
//   teleport.value.parentNode.removeChild(teleport.value)
// })
</script>

<template>
  <div class="nio-teleport" ref="teleport">
    <slot/>
  </div>
</template>
